const ERROR_MESSAGE = `need roles! Like v-permission="['crm.functional.bill.flow','crm.setting.email.recycle']"`

const hasRoles = (privilege, needRoles) => {
  const { roles, scopeMap } = needRoles.reduce(
    ({ roles, scopeMap }, next) =>
      typeof next === "string"
        ? { roles: [...roles, next], scopeMap: scopeMap }
        : {
            roles: [...roles, next.key],
            scopeMap: {
              ...scopeMap,
              [next.key]: next.scope,
            },
          },
    {
      roles: [],
      scopeMap: {},
    },
  )

  return roles.some(
    role =>
      privilege.list.includes(role) &&
      (role in scopeMap
        ? scopeMap[role].includes(privilege.user[role].scope)
        : true),
  )
}

export function hasPermission(privilege, roles) {
  if (!roles) {
    return true
  }

  return roles.handle
    ? roles.handle(roles.value, privilege.list, privilege.user)
    : hasRoles(privilege, roles)
}

export function checkPermission(value, privilege) {
  if (value) {
    const roles = Array.isArray(value) ? value : [value]
    return hasPermission(privilege, roles)
  } else {
    return false
  }
}

export function checkAndPermission(value, privilege) {
  return value.every(role => checkPermission(role, privilege))
}

export default {
  inserted(el, binding) {
    const { value } = binding

    if (Array.isArray(value) && value.length > 0) {
      if (!hasPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new TypeError(ERROR_MESSAGE)
    }
  },
}
